import { Link } from "react-router-dom";
import { CONTACT } from "../lib/data";

const LOGO_URL = "/wertbild-logo-light.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0E0E0E] text-[#F5F2EC]">
      <div className="container-x py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src={LOGO_URL}
            alt="Wertbild Immobilienfotografie"
            className="h-10 md:h-12 w-auto block"
          />
          <p className="mt-8 text-sm leading-relaxed text-[#A8A59E] max-w-md font-light">
            Professionelle Immobilienfotografie, Architekturfotografie, Drohnenaufnahmen,
            3D-Touren und visuelle Objektpräsentation für Makler, Eigentümer, Bauträger
            und Gewerbekunden in NRW.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#FFA500]">Kontakt</div>
          <ul className="mt-5 space-y-2 text-sm text-[#A8A59E] font-light">
            <li className="text-[#F5F2EC]">{CONTACT.brand}</li>
            <li>{CONTACT.street}</li>
            <li>{CONTACT.zip} {CONTACT.city}</li>
            <li className="pt-3">
              <a href="tel:+4924212633703" className="hover:text-[#FFA500] transition-colors">{CONTACT.phone}</a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#FFA500] transition-colors">{CONTACT.email}</a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="overline text-[#FFA500]">Öffnungszeiten</div>
          <ul className="mt-5 space-y-2 text-sm text-[#A8A59E] font-light">
            {CONTACT.hours.map((h) => (
              <li key={h.d}>
                <div className="text-[#F5F2EC]">{h.d}</div>
                <div className="text-[#6B6B66]">{h.t}</div>
              </li>
            ))}
            {CONTACT.note && (
              <li className="pt-2 text-[#F5F2EC]">{CONTACT.note}</li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1F1F1F]">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-[#6B6B66]">© {year} {CONTACT.brand} · Alle Rechte vorbehalten.</p>
          <div className="flex gap-6 text-xs text-[#A8A59E]">
            <Link to="/agb" data-testid="footer-agb" className="hover:text-[#FFA500] transition-colors">AGB</Link>
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-[#FFA500] transition-colors">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-[#FFA500] transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
